(function() {
  var BaseController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseController = App.loadClass('core::Angular/UsernameDropdown/BaseController');

  exports.ContactInfoController = (function(superClass) {
    extend(ContactInfoController, superClass);

    function ContactInfoController(q, scope, transitions, modalInstance, user, states, additionalValidation, service, timeout, window1, ngModal) {
      this.q = q;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.timeout = timeout;
      this.window = window1;
      this.ngModal = ngModal;
      this.save = bind(this.save, this);
      this.saveRequest = bind(this.saveRequest, this);
      this.cancel = bind(this.cancel, this);
      ContactInfoController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance, this.service);
      this.scope.title = 'Edit Contact Info';
      this.scope.states = states.states;
      this.scope.user = user;
      this.scope.additionalValidation = additionalValidation;
      this.timeout(function() {
        return angular.element(this.window).trigger('resize');
      });
      this.scope.isCanadian = window.Config.get('app.locale') === 'en_CA';
      this.scope.initialPhoneNumber = user.phone != null ? user.phone.replace(/[\D]+/g, '') : null;
      if (!additionalValidation) {
        this.service.phoneNumberConfirmed().then((function(_this) {
          return function(response) {
            return _this.scope.phoneNumberConfirmed = !!response.data;
          };
        })(this));
      }
    }

    ContactInfoController.prototype.cancel = function() {
      this.scope.user.phone = this.scope.user.phone != null ? this.scope.user.phone.replace(/[\D]+/g, '') : void 0;
      if (this.scope.initialPhoneNumber !== this.scope.user.phone) {
        this.service.updateUnconfirmedNumber(this.scope.initialPhoneNumber);
      }
      return this.modalInstance.dismiss('cancel');
    };

    ContactInfoController.prototype.saveRequest = function(pretend) {
      if (pretend == null) {
        pretend = false;
      }
      return this.service.saveContact(pretend, this.scope.user, this.scope.additionalValidation).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          if (!pretend) {
            if (!_this.scope.additionalValidation) {
              _this.scope.$root.$broadcast('username.dropdown.contactInfo:save', _this.scope.user);
            }
            return _this.closeWithAlert(jsr.status);
          }
        };
      })(this));
    };

    ContactInfoController.prototype.save = function(pretend) {
      if (pretend == null) {
        pretend = false;
      }
      this.scope.user.phone = this.scope.user.phone != null ? this.scope.user.phone.replace(/[\D]+/g, '') : void 0;
      if (!pretend && this.scope.initialPhoneNumber !== this.scope.user.phone && this.scope.phoneNumberConfirmed && !!this.scope.user.phone) {
        return this.service.updateUnconfirmedNumber(this.scope.user.phone).then((function(_this) {
          return function() {
            return _this.ngModal.launchSecurityCodeDialog().modalRef.result.then(function() {
              return _this.saveRequest(pretend);
            });
          };
        })(this));
      } else {
        if (!pretend) {
          this.scope.setAlert({
            msg: 'Saving Contact Info...',
            type: 'info'
          });
        }
        return this.saveRequest(pretend);
      }
    };

    return ContactInfoController;

  })(BaseController);

}).call(this);
